import like from './1f44d.png'
import smile from './1f606.png'
import angry from './1f624.png'
import sad from './1f62d.png'
import wow from './1f632.png'
import love from './2764.png'

const EMOJI = {
    like,
    smile,
    angry,
    sad,
    wow,
    love
}

export default EMOJI
